module.exports = __webpack_public_path__ + "static/media/Logo_DM2.4e2a6996.png";